import { isAppLoading } from '../../selectors'
import { stateList } from '../../../common/helpers'

const mapStateToProps = (state, props) => ({
  stateList: props.stateList || stateList,
  countries: state.account.countries,
  isLoading: isAppLoading(state)
})

export default mapStateToProps
